export const arrangeSidebarMenuItems = (items = []) => {
  const visibleItems = items.filter((item) => item?.label !== "Sports");
  const canRedirect = (item) => Boolean(item?.path || item?.externalUrl || item?.action);

  return [
    ...visibleItems.filter(canRedirect),
    ...visibleItems.filter((item) => !canRedirect(item)),
  ];
};
